"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NestedAccordion = function NestedAccordion(_ref) {
  var activeGroupIndex = _ref.activeGroupIndex,
    scoringGroups = _ref.scoringGroups,
    onTitleClick = _ref.onTitleClick;
  return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Accordion, {
    activeIndex: activeGroupIndex,
    panels: scoringGroups,
    onTitleClick: onTitleClick,
    fluid: true,
    styled: true,
    className: "gmmNestedAccordion"
  });
};
NestedAccordion.propTypes = {
  activeGroupIndex: _propTypes.default.number.isRequired,
  scoringGroups: _propTypes.default.array.isRequired,
  onTitleClick: _propTypes.default.func.isRequired
};
var _default = NestedAccordion;
exports.default = _default;